import { ReactNode } from "react";

import Typography from "ds/components/Typography";

import { FormFieldColor } from "./types";
import { getColors } from "./utils";
import styles from "./styles.module.css";

type FormFieldLabelProps = {
  id?: string;
  label?: string | ReactNode;
  isOptional?: boolean;
  htmlFor?: string; // TODO this should be required
  color?: FormFieldColor;
};

const FormFieldLabel = ({ id, label, isOptional, htmlFor, color }: FormFieldLabelProps) => {
  const { primaryTextColor, secondaryColor } = getColors(color);

  return (
    <Typography
      id={id}
      htmlFor={htmlFor}
      tag="label"
      className={styles.labelText}
      color={primaryTextColor}
    >
      {label}
      {isOptional && (
        <>
          {" "}
          <Typography className={styles.labelTextOptional} tag="span" color={secondaryColor}>
            (Optional)
          </Typography>
        </>
      )}
    </Typography>
  );
};

FormFieldLabel.displayName = "DS.Form.Field.Label";

export default FormFieldLabel;
